import { render, staticRenderFns } from "./SpyderSearchResults.vue?vue&type=template&id=567a9009&scoped=true"
import script from "./SpyderSearchResults.vue?vue&type=script&lang=js"
export * from "./SpyderSearchResults.vue?vue&type=script&lang=js"
import style0 from "./SpyderSearchResults.vue?vue&type=style&index=0&id=567a9009&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a9009",
  null
  
)

export default component.exports